module.exports = __webpack_public_path__ + "assets/fonts/e0d53e11-f301-4274-8e4f-8cae12b62c79.9bb6da2a.woff";